import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import {
  MovementList,
  undoMovementList,
  redoMovementList,
  calculateIPRToothForNegation,
  clearRedoMovementList,
  MovementTypes,
} from "./TeethPositionHelper";
import * as THREE from "three";
import {
  Controller,
  attachmentMaterial as oldAttachmentMaterial,
} from "../Mesh";
import {
  teethMaterial,
  selectedTeethMaterial,
  lockedTeethMaterial,
} from "../Mesh";
import { getParams } from "@/helpers/getParams";
import { addEventListener, removeListenersFrom } from "@/helpers/clickManager";
import {
  customTeethGizmoControls,
  perspectiveCamera,
  setOrbitControlsEnabled,
} from "../Camera";
import { undoRef } from "./URR";
import { isLeftShiftDown } from "./TeethControls";
import { Vector3 } from "three";
import { SingletonManager } from "../../../helpers/singletonInitializer.ts";
import { removeAllChildren } from "../../hierarchyHelper.js";
import { globalData } from "../../../helpers/globData.ts";
export let previousSelectedTooth, secondPreviousTooth;
export let isReset = false;

SingletonManager.initializeAll();

export function setIsReset(state) {
  isReset = state;
}

export function getIsReset(state) {
  return isReset;
}

export const newAttachmentMaterial =
  SingletonManager.materialManager.createMaterial("MeshPhysicalMaterial", {
    color: 0x89cff0,
    roughness: 0,
    transparent: true,
    name: "newAttachmentMaterial",
  });

export const selectedAttachmentMaterial =
  SingletonManager.materialManager.createMaterial("MeshPhysicalMaterial", {
    color: 0xfcbd00,
    roughness: 0,
    transparent: false,
    name: "selectedAttachmentMaterial",
  });
export const names = [
  "att_hbra",
  "att_vbra",
  "att_oblique",
  "att_extrusion",
  "att_biolane",
  "att_root_control",
  "att_rotational",
];
/**
 * sorted in same orders as in (names) array
 */
export let attachmentsObjects = [];

let deletedAtt,
  selectedAtt,
  attachmentIDCounter = 0;

export function setSelectedAtt(attachment) {
  if (selectedAtt) {
    if (!Controller.isRotating) {
      Controller.detach();
    }

    if (selectedAtt.userData["type"] === "old") {
      selectedAtt.material = oldAttachmentMaterial;
    } else {
      selectedAtt.material = newAttachmentMaterial;
    }
  }
  selectedAtt = attachment;
  if (attachment) {
    selectedAtt.material = selectedAttachmentMaterial;
    if (selectedAtt.userData["type"] === "new") {
      Controller.attach(attachment);
    }
  }
}
export function deleteSelectedAttachment() {
  if (selectedAtt) {
    deleteAttachment(selectedAtt);
    setSelectedAtt(null);
    return true;
  }
  return false;
}
export function setDeletedAtt(newDeletedAtt, ignoreAutoSave = false) {
  if (newDeletedAtt != deletedAtt && !ignoreAutoSave) {
    setAutoSave1();
  }
  deletedAtt = newDeletedAtt;
}

export function setAttachmentArray(attachmentArray) {
  attachmentArray1 = attachmentArray;
}
export let logs1,
  setLogs1,
  setAutoSave1,
  attachmentArray1,
  setControls3D1,
  isFilled = false;

export let isUIHold = false;

export function setIsUIHold(state) {
  isUIHold = state;
}

export function selectTooth(
  event,
  camera,
  raycaster,
  pointer,
  list,
  teethMaterial,
  scene,
  center,
  setControls3D,
  selectedTooth,
  selectedAttachmentType,
  selectedAttachment,
  numberingOverLays,
  GLBData,
  model,
  setModel,
  groupRef,
  showUpper,
  showLower,
  logs,
  setLogs,
  setScene,
  attachmentArray,
  setAutoSave,
) {
  setScene(scene);
  pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
  pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
  if (event.button === 0) {
    raycaster.setFromCamera(pointer, camera.current);
    const intersects = raycaster.intersectObjects(list, false);
    let mesial;
    if (intersects.length > 0) {
      const box3 = new THREE.Box3().setFromObject(intersects[0].object);
      const point = new THREE.Vector3();
      //console.log(box3.getCenter(point));
      if (box3.getCenter(point).x < 0) {
        mesial = true;
      } else {
        mesial = false;
      }
    }
    //console.log(intersects[0].object.name.includes("u"), "UwU rar XD");
    onPointerMove(
      event,
      camera,
      raycaster,
      pointer,
      list,
      teethMaterial,
      scene,
      center,
      setControls3D,
      selectedTooth,
      selectedAttachmentType,
      selectedAttachment,
      mesial,
      GLBData,
      model,
      setModel,
      groupRef,
      logs,
      setLogs,
      attachmentArray,
      setAutoSave,
    );
  }
}
export function prepareAttachmentsUtilities(
  logs,
  setAutoSave,
  setLogs,
  setControls3D,
) {
  if (!isFilled) {
    logs1 = logs;
    setAutoSave1 = setAutoSave;
    // attachmentArray1 = attachmentArray;
    setLogs1 = setLogs;
    setControls3D1 = setControls3D;
    isFilled = true;
  }
}

// teeth selection
export function onPointerMove(
  event,
  camera,
  raycaster,
  pointer,
  list,
  teethMaterial,
  scene,
  center,
  setControls3D,
  selectedTooth,
  selectedAttachmentType,
  selectedAttachment,
  mesial,
  GLBData,
  model,
  setModel,
  groupRef,
  logs,
  setLogs,
  attachmentArray,
  setAutoSave,
) {
  if (!isFilled) {
    logs1 = logs;
    setAutoSave1 = setAutoSave;
    // attachmentArray1 = attachmentArray;
    setLogs1 = setLogs;
    selectedAttachmentType1 = selectedAttachmentType;
    setControls3D1 = setControls3D;
    selectedTooth1 = selectedTooth;
    isFilled = true;
  }
  return;
}
function registerAddingAttachment(tooth, attachment, isDragDropCall = false) {
  undoMovementList.push({
    actionType: "attachments",
    tooth: tooth,
    attachmentID: attachment.customID,
    attachmentName: attachment.name,
    relativePosition: attachment.position.clone(),
    relativeRotation: attachment.rotation.clone(),
    action: "add",
    continue: isDragDropCall,
  });
  let selectedToothNum = tooth.name.split("_")[2].substring(1, 4);
  let action;
  if (attachmentArray1[selectedToothNum]?.length > 0) {
    action = "add";
  } else {
    action = "add";
  }
  let key = selectedToothNum.toString() + "_Movement";
  if (!logs1[key]) {
    logs1[key] = {};
    logs1[key][MovementTypes.MESIALDISTAL] = 0;
    logs1[key][MovementTypes.BUCCALLINGUAL] = 0;
    logs1[key][MovementTypes.EXTRUSIONINTRUSION] = 0;
    logs1[key][MovementTypes.ROTATION] = 0;
    logs1[key][MovementTypes.ANGULATION] = 0;
    logs1[key][MovementTypes.INCLINATION] = 0;
    logs1[key][MovementTypes.LEFTHINGE] = 0;
    logs1[key][MovementTypes.RIGHTHINGE] = 0;
  }
  if (!logs1[key].hasOwnProperty("attachment")) {
    logs1[key]["attachment"] = {};
  }
  logs1[key]["attachment"][attachment.customID] = {
    action: action,
    type: attachment.name,
  };

  setLogs1(logs1);
  // setAutoSave1();
  clearRedoMovementList();
}
export function addRemoveAttachment(scene) {
  const loader = new GLTFLoader();
  Promise.all([
    loader.loadAsync("att_hbra.glb"),
    loader.loadAsync("att_vbra.glb"),
    loader.loadAsync("att_oblique.glb"),
    loader.loadAsync("att_extrusion.glb"),
    loader.loadAsync("att_biolane.glb"),
    loader.loadAsync("att_root_control.glb"),
    loader.loadAsync("att_rotational.glb"),
  ])
    .then(results => {
      results.forEach((model, i) => {
        model.scene.children[0].name = names[i];
        model.scene.children[0].userData["type"] = "new";
        attachmentsObjects.push(model.scene.children[0]);
        // modelA.scene.children[0].scale.multiply(new THREE.Vector3(1, 1, -1));
        model.scene.children[0].material.transparent = true;
        model.scene.children[0].material.opacity = 0;
        model.scene.children[0].visible = false;
        // model.scene.children[0].position.copy(center);
        scene.add(model.scene.children[0]);
      });
    })
    .catch(err => {
      console.log(err);
    });
}
function disableToothAnchor(tooth) {
  console.log(tooth, "off");
  if (!tooth) {
    return;
  }
  for (let i = 0; i < tooth.children[3].children.length; i++) {
    if (tooth.children[3].children[i].name.includes("root")) {
      tooth.children[3].children[i].visible = false;
      console.log("Rooty off");
    }
  }
}
function enableToothAnchor(tooth) {
  for (let i = 0; i < tooth.children[3].children.length; i++) {
    if (tooth.children[3].children[i].name.includes("root")) {
      tooth.children[3].children[i].visible = true;
      console.log("Rooty on");
    }
  }
}
function addAttachmentToTooth(attachmentObject, clickRayCast) {
  if (!attachmentObject) {
    attachmentObject = deletedAtt;
  }
  let attachment, parentTooth;
  attachment = attachmentObject.clone();
  attachment.customID = attachmentObject.customID;
  parentTooth = clickRayCast.object;

  parentTooth.children[0].add(attachment);
  let permaVector = parentTooth.worldToLocal(clickRayCast.point.clone());
  attachment.position.copy(permaVector);
  attachment.lookAt(clickRayCast.point.sub(clickRayCast.face.normal));
  attachment.material = newAttachmentMaterial;
  attachment.visible = true;
  attachment.updateWorldMatrix();

  subscribeAttachmentToListener(attachment);
}

// delete all attachments on tooth
export function deleteAllAttachmentsFromTooth(tooth, saveAction = true) {
  for (let i = 0; i < tooth.children[0].children.length; i++) {
    if (tooth.children[0].children[i].name.includes("att")) {
      if (saveAction) {
        undoMovementList.push({
          actionType: "attachments",
          tooth: tooth,
          action: "remove",
          attachmentName: tooth.children[0].children[i].name,
          relativePosition: tooth.children[0].children[i].position.clone(),
          relativeRotation: tooth.children[0].children[i].rotation.clone(),
        });
      }
      removeListenersFrom(tooth.children[0].children[i]);
      return tooth.children[0].children[i].removeFromParent();
    }
  }
}
//
export function deleteAttachment(attachment, saveAction = true) {
  console.log(attachment.name);

  if (attachment.name.includes("att")) {
    const toothNum = attachment.parent.parent.userData["number"];
    if (saveAction) {
      undoMovementList.push({
        actionType: "attachments",
        tooth: attachment.parent.parent,
        action: "remove",
        attachmentID: attachment.customID,
        attachmentName: attachment.name,
        relativePosition: attachment.position.clone(),
        relativeRotation: attachment.rotation.clone(),
      });
    }

    if (
      logs1[toothNum + "_Movement"]?.attachment?.hasOwnProperty(
        attachment.customID,
      ) &&
      logs1[toothNum + "_Movement"].attachment[attachment.customID].type !==
        "_att"
    ) {
      // deleting new attachments
      delete logs1[toothNum + "_Movement"].attachment[attachment.customID];
    } else {
      // deleting existing attachment
      const key = toothNum + "_Movement";
      if (!logs1[key]) {
        logs1[key] = {};
        logs1[key][MovementTypes.MESIALDISTAL] = 0;
        logs1[key][MovementTypes.BUCCALLINGUAL] = 0;
        logs1[key][MovementTypes.EXTRUSIONINTRUSION] = 0;
        logs1[key][MovementTypes.ROTATION] = 0;
        logs1[key][MovementTypes.ANGULATION] = 0;
        logs1[key][MovementTypes.INCLINATION] = 0;
        logs1[key][MovementTypes.LEFTHINGE] = 0;
        logs1[key][MovementTypes.RIGHTHINGE] = 0;
      }
      if (!logs1[key].hasOwnProperty("attachment")) {
        logs1[key]["attachment"] = {};
      }
      logs1[key]["attachment"][attachment.customID] = {
        action: "remove",
        type: attachment.name,
      };
    }
    setLogs1(logs1);
    removeListenersFrom(attachment);
    return attachment.removeFromParent();
  }
}

export function prepareAttachment3DControlslisteners(upperLowerGroup) {
  for (let jawIndex = 0; jawIndex < 2; jawIndex++) {
    for (
      let toothIndex = 0;
      toothIndex < upperLowerGroup[jawIndex].children.length;
      toothIndex++
    ) {
      addEventListener(
        upperLowerGroup[jawIndex].children[toothIndex],
        "mousedown",
        raycasterInfo => {
          if (globalData.toggles.showContModification) {
            return;
          }
          isReset = false;
          setControls3D1("activeControlTab", "teeth");
          if (!isLeftShiftDown) {
            setSelectedAtt(null);
            const tempName = raycasterInfo.object.name;

            if (tempName.charAt(0) === "u") {
              setControls3D1("isUpper", true);
            } else {
              setControls3D1("isUpper", false);
            }
            if (Array.isArray(previousSelectedTooth)) {
              previousSelectedTooth.forEach(tooth => {
                tooth.material = teethMaterial;
                if (tooth.children[3].children[0]) {
                  tooth.children[3].children[0].material = teethMaterial;
                }
              });
            } else if (previousSelectedTooth) {
              previousSelectedTooth.material = previousSelectedTooth?.userData[
                "isLocked"
              ]
                ? lockedTeethMaterial
                : teethMaterial;
              if (previousSelectedTooth.children[3].children[0]) {
                previousSelectedTooth.children[3].children[0].material =
                  previousSelectedTooth?.userData["isLocked"]
                    ? lockedTeethMaterial
                    : teethMaterial;
              }
            }
            raycasterInfo.object.material = raycasterInfo.object?.userData[
              "isLocked"
            ]
              ? lockedTeethMaterial
              : selectedTeethMaterial;

            if (raycasterInfo.object.children[3].children[0]) {
              raycasterInfo.object.children[3].children[0].material =
                raycasterInfo.object.userData["isLocked"]
                  ? lockedTeethMaterial
                  : selectedTeethMaterial;
            }
            setControls3D1("selectedTooth", raycasterInfo.object);
            const toothData = raycasterInfo.object.userData;

            customTeethGizmoControls.attachTo(raycasterInfo.object, {
              X: customTeethGizmoControls.getPerpendicularXZ(toothData.zAxis),
              Y: new Vector3(0, 1, 0),
              Z: toothData.zAxis.clone(),
            });
            customTeethGizmoControls.setIsEnabled(true);
            previousSelectedTooth = raycasterInfo.object;
            calculateIPRToothForNegation(previousSelectedTooth, 1);
            calculateIPRToothForNegation(previousSelectedTooth, -1);
          } else {
            setSelectedAtt(null);
            const tempName = raycasterInfo.object.name;

            if (tempName.charAt(0) === "u") {
              setControls3D1("isUpper", true);
            } else {
              setControls3D1("isUpper", false);
            }
            const isArray = Array.isArray(previousSelectedTooth);
            if (isArray) {
              previousSelectedTooth.forEach(tooth => {
                tooth.material = teethMaterial;
                if (tooth.children[3].children[0]) {
                  tooth.children[3].children[0].material = teethMaterial;
                }
              });
            } else {
              if (previousSelectedTooth) {
                previousSelectedTooth.material = teethMaterial;
                if (previousSelectedTooth.children[3].children[0]) {
                  previousSelectedTooth.children[3].children[0].material =
                    teethMaterial;
                }
              }
            }
            if (
              !previousSelectedTooth ||
              (!isArray &&
                tempName.charAt(0) !==
                  previousSelectedTooth?.name?.charAt(0)) ||
              (isArray &&
                tempName.charAt(0) !==
                  previousSelectedTooth[0]?.name?.charAt(0))
            ) {
              raycasterInfo.object.material = raycasterInfo.object?.userData[
                "isLocked"
              ]
                ? lockedTeethMaterial
                : selectedTeethMaterial;

              if (raycasterInfo.object.children[3].children[0]) {
                raycasterInfo.object.children[3].children[0].material =
                  raycasterInfo.object.userData["isLocked"]
                    ? lockedTeethMaterial
                    : selectedTeethMaterial;
              }
              setControls3D1("selectedTooth", raycasterInfo.object);
              customTeethGizmoControls.setIsEnabled(true);
              previousSelectedTooth = raycasterInfo.object;
              secondPreviousTooth = undefined;
              calculateIPRToothForNegation(previousSelectedTooth, 1);
              calculateIPRToothForNegation(previousSelectedTooth, -1);
            } else {
              let selectedTeeth;
              if (Array.isArray(previousSelectedTooth)) {
                selectedTeeth = getAllTeethInRange(
                  secondPreviousTooth,
                  raycasterInfo.object,
                );
              } else {
                secondPreviousTooth = previousSelectedTooth;
                selectedTeeth = getAllTeethInRange(
                  previousSelectedTooth,
                  raycasterInfo.object,
                );
              }
              if (!selectedTeeth) {
                return;
              }
              selectedTeeth.forEach(tooth => {
                tooth.material = tooth?.userData["isLocked"]
                  ? lockedTeethMaterial
                  : selectedTeethMaterial;
                if (tooth.children[3].children[0]) {
                  tooth.children[3].children[0].material = tooth.userData[
                    "isLocked"
                  ]
                    ? lockedTeethMaterial
                    : selectedTeethMaterial;
                }
                calculateIPRToothForNegation(tooth, 1);
                calculateIPRToothForNegation(tooth, -1);
              });
              customTeethGizmoControls.setObjects(selectedTeeth);

              setControls3D1("selectedTooth", selectedTeeth);
              customTeethGizmoControls.setIsEnabled(true);

              previousSelectedTooth = selectedTeeth;
            }
          }
        },
      );
      addEventListener(
        upperLowerGroup[jawIndex].children[toothIndex],
        "mouseup",
        raycasterInfo => {
          if (deletedAtt) {
            console.log(selectedAtt);

            if (deletedAtt.userData["type"] === "new") {
              if (!deletedAtt.customID) {
                deletedAtt.customID = attachmentIDCounter++;
              }
              addAttachmentToTooth(null, raycasterInfo);
              registerAddingAttachment(
                raycasterInfo.object,
                deletedAtt,
                !isUIHold,
              );
              deletedAtt = null;
              setAutoSave1(true);
            } else {
              //undo
              console.log("undoing");
              undoRef();
              redoMovementList.pop();
              setAutoSave1();
              setControls3D1("isExistingAttachments", true);

              // console.log("toast for existing attachments");
            }
          }
        },
      );

      for (
        let attachmentIndex = 0;
        attachmentIndex <
        upperLowerGroup[jawIndex].children[toothIndex].children[0].children
          .length;
        attachmentIndex++
      ) {
        // give custom ID to existing attachments
        attachmentArray1[
          upperLowerGroup[jawIndex].children[toothIndex].name
            .split("_")[2]
            .substring(1)
        ][attachmentIndex].customID = attachmentIDCounter;

        upperLowerGroup[jawIndex].children[toothIndex].children[0].children[
          attachmentIndex
        ].customID = attachmentIDCounter++;

        subscribeAttachmentToListener(
          upperLowerGroup[jawIndex].children[toothIndex].children[0].children[
            attachmentIndex
          ],
        );
      }
    }
  }
}

function getAllTeethInRange(firstTooth, secondTooth) {
  if (firstTooth.parent !== secondTooth.parent) {
    return;
  }
  const parent = firstTooth.parent;
  const firstToothIndex = parent.children.indexOf(firstTooth);
  const secondToothIndex = parent.children.indexOf(secondTooth);

  return firstToothIndex < secondToothIndex
    ? parent.children.slice(firstToothIndex, secondToothIndex + 1)
    : parent.children.slice(secondToothIndex, firstToothIndex + 1);
}

export function subscribeAttachmentToListener(attachment) {
  addEventListener(attachment, "mousedown", raycasterInfo => {
    if (
      Controller.isHovered() ||
      customTeethGizmoControls.isHovered() ||
      globalData.toggles.showContModification
    ) {
      return;
    }
    isReset = false;
    if (!isLeftShiftDown) {
      setSelectedAtt(raycasterInfo.object);
      resetSelectedTooth();
      setControls3D1("activeControlTab", "auxiliaries");
    }
  });

  addEventListener(attachment, "mousehold", raycasterInfo => {
    // update the cursor image1
    // select attachment
    if (
      Controller.isHovered() ||
      customTeethGizmoControls.isHovered() ||
      globalData.toggles.showContModification
    ) {
      return;
    }
    if (raycasterInfo.object.userData["type"] === "old") {
      setControls3D1("selectedAttachmentType", "att_default");
    } else {
      setControls3D1("selectedAttachmentType", raycasterInfo.object.name);
    }
    setOrbitControlsEnabled(false);
    Controller.detach();
    deletedAtt = deleteAttachment(
      raycasterInfo.object.parent.name.includes("multi")
        ? raycasterInfo.object.parent
        : raycasterInfo.object,
      true,
    );
    deletedAtt.position.copy(0, 0, 0);
    removeListenersFrom(raycasterInfo.object);
  });
}

export function resetSelectedTooth() {
  if (previousSelectedTooth) {
    if (Array.isArray(previousSelectedTooth)) {
      previousSelectedTooth.forEach(tooth => {
        tooth.material = teethMaterial;
        if (tooth.children[3].children[0]) {
          tooth.children[3].children[0].material = teethMaterial;
        }
      });
    } else {
      previousSelectedTooth.material = previousSelectedTooth?.userData[
        "isLocked"
      ]
        ? lockedTeethMaterial
        : teethMaterial;

      if (previousSelectedTooth.children[3].children[0]) {
        previousSelectedTooth.children[3].children[0].material =
          previousSelectedTooth?.userData["isLocked"]
            ? lockedTeethMaterial
            : teethMaterial;
      }
    }
  }
  if (setControls3D1) {
    setControls3D1("selectedTooth", null);
    customTeethGizmoControls.setIsEnabled(false);
  }
  previousSelectedTooth = null;
}

let savedAttachments = [];
export function save3DStepAttachments(step) {
  savedAttachments = [];
  for (let jawIndex = 0; jawIndex < 2; jawIndex++) {
    const jaw = step.children[jawIndex];
    for (let toothIndex = 0; toothIndex < jaw.children.length; toothIndex++) {
      const tooth = jaw.children[toothIndex];
      const toothAttGroup = tooth.children[0];
      const toothNum = tooth.userData["number"];
      for (
        let attIndex = 0;
        attIndex < toothAttGroup.children.length;
        attIndex++
      ) {
        if (!savedAttachments[toothNum]) {
          savedAttachments[toothNum] = [];
        }
        savedAttachments[toothNum].push(toothAttGroup.children[attIndex]);
      }
    }
  }
}

export function reApplySavedAttachments(step) {
  for (let jawIndex = 0; jawIndex < 2; jawIndex++) {
    const jaw = step.children[jawIndex];
    for (let toothIndex = 0; toothIndex < jaw.children.length; toothIndex++) {
      const tooth = jaw.children[toothIndex];
      const toothAttGroup = tooth.children[0];
      const toothNum = tooth.userData["number"];
      removeAllChildren(toothAttGroup);

      for (
        let attIndex = 0;
        attIndex < savedAttachments[toothNum]?.length;
        attIndex++
      ) {
        toothAttGroup.add(savedAttachments[toothNum][attIndex]);
      }
    }
  }
}
